import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { ICaliforniaLookupParams } from '../../../../Models/ICaliforniaLookupParams';
import { FormCaliforniaAssessmentTestService } from '../../../../Services/FormCaliforniaAssessmentTestService';
import { IFormCaliforniaAssessmentTest } from "../../../../Models/Forms/IFormCaliforniaAssessmentTest";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ReportService } from 'src/app/Services/ReportService';
import { SpinnerBase } from 'src/app/Components/Base/SpinnerBase';
import { IReportRequestExcelBased } from '../../../../Models/IReportRequestExcelBased';
import { IReportCSV } from '../../../../Models/IReportCSV';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
//import { Date } from 'core-js';

@Component({
  selector: 'CaliforniaAssessmentTest',
  templateUrl: './CaliforniaAssessmentTest.component.html',
  styleUrls: ['./CaliforniaAssessmentTest.component.css']
})

export class FormCaliforniaAssessmentTestComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  selectionMsg: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  _lookupService: LookupService;
  _lookupBaseArray: ILookupBase[];
  formCaliforniaAssessmentTestDB: any = [];
  reportParamArray: IReportParameter[];

  listLookupELATestIds: ILookupBase[];
  listLookupMathematicsTestIds: ILookupBase[];
  listLookupScienceTestIds: ILookupBase[];
  listLookupELPTestIds: ILookupBase[];

  _lookupCAASSP_ELA_UniversalTools_Embeded: ILookupBase[];
  _lookupCAASSP_ELA_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupCAASSP_Mathematics_UniversalTools_Embeded: ILookupBase[];
  _lookupCAASSP_Mathematics_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupCAASSP_Science_UniversalTools_Embeded: ILookupBase[];
  _lookupCAASSP_Science_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupCAASSP_ELA_DesignatedSupports_Embeded: ILookupBase[];
  _lookupCAASSP_ELA_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupCAASSP_Mathematics_DesignatedSupports_Embeded: ILookupBase[];
  _lookupCAASSP_Mathematics_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupCAASSP_Science_DesignatedSupports_Embeded: ILookupBase[];
  _lookupCAASSP_Science_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupCAASSP_ELA_Accommodations_Embeded: ILookupBase[];
  _lookupCAASSP_ELA_Accommodations_NotEmbeded: ILookupBase[];
  _lookupCAASSP_Mathematics_Accommodations_Embeded: ILookupBase[];
  _lookupCAASSP_Mathematics_Accommodations_NotEmbeded: ILookupBase[];
  _lookupCAASSP_Science_Accommodations_Embeded: ILookupBase[];
  _lookupCAASSP_Science_Accommodations_NotEmbeded: ILookupBase[];

  selectedElaUniversalToolsEmbededIds: any[];
  selectedElaDesignatedSupportsEmbededIds: any[];
  selectedElaAccommodationsEmbededIds: any[];
  selectedElaUniversalToolsNonEmbededIds: any[];
  selectedElaDesignatedSupportsNonEmbededIds: any[];
  selectedElaAccommodationsNonEmbededIds: any[];
  selectedMathematicsUniversalToolsEmbededIds: any[];
  selectedMathematicsDesignatedSupportsEmbededIds: any[];
  selectedMathematicsAccommodationsEmbededIds: any[];
  selectedMathematicsUniversalToolsNonEmbededIds: any[];
  selectedMathematicsDesignatedSupportsNonEmbededIds: any[];
  selectedMathematicsAccommodationsNonEmbededIds: any[];
  selectedScienceUniversalToolsEmbededIds: any[];
  selectedScienceDesignatedSupportsEmbededIds: any[];
  selectedScienceAccommodationsEmbededIds: any[];
  selectedScienceUniversalToolsNonEmbededIds: any[];
  selectedScienceDesignatedSupportsNonEmbededIds: any[];
  selectedScienceAccommodationsNonEmbededIds: any[];

  _lookupELP_Listening_UniversalTools_Embeded: ILookupBase[];
  _lookupELP_Listening_DesignatedSupports_Embeded: ILookupBase[];
  _lookupELP_Listening_Accommodations_Embeded: ILookupBase[];
  _lookupELP_Speaking_UniversalTools_Embeded: ILookupBase[];
  _lookupELP_Speaking_DesignatedSupports_Embeded: ILookupBase[];
  _lookupELP_Speaking_Accommodations_Embeded: ILookupBase[];
  _lookupELP_Reading_UniversalTools_Embeded: ILookupBase[];
  _lookupELP_Reading_DesignatedSupports_Embeded: ILookupBase[];
  _lookupELP_Reading_Accommodations_Embeded: ILookupBase[];
  _lookupELP_Writing_UniversalTools_Embeded: ILookupBase[];
  _lookupELP_Writing_DesignatedSupports_Embeded: ILookupBase[];
  _lookupELP_Writing_Accommodations_Embeded: ILookupBase[];

  selectedELPListeningUniversalToolsEmbededIds: any[];
  selectedELPListeningDesignatedSupportsEmbededIds: any[];
  selectedELPListeningAccommodationsEmbededIds: any[];
  selectedELPSpeakingUniversalToolsEmbededIds: any[];
  selectedELPSpeakingDesignatedSupportsEmbededIds: any[];
  selectedELPSpeakingAccommodationsEmbededIds: any[];
  selectedELPReadingUniversalToolsEmbededIds: any[];
  selectedELPReadingDesignatedSupportsEmbededIds: any[];
  selectedELPReadingAccommodationsEmbededIds: any[];
  selectedELPWritingUniversalToolsEmbededIds: any[];
  selectedELPWritingDesignatedSupportsEmbededIds: any[];
  selectedELPWritingAccommodationsEmbededIds: any[];

  _lookupELP_Listening_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupELP_Listening_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupELP_Listening_Accommodations_NotEmbeded: ILookupBase[];
  _lookupELP_Speaking_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupELP_Speaking_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupELP_Speaking_Accommodations_NotEmbeded: ILookupBase[];
  _lookupELP_Reading_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupELP_Reading_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupELP_Reading_Accommodations_NotEmbeded: ILookupBase[];
  _lookupELP_Writing_UniversalTools_NotEmbeded: ILookupBase[];
  _lookupELP_Writing_DesignatedSupports_NotEmbeded: ILookupBase[];
  _lookupELP_Writing_Accommodations_NotEmbeded: ILookupBase[];


  selectedELPListeningUniversalToolsNonEmbededIds: any[];
  selectedELPListeningDesignatedSupportsNonEmbededIds: any[];
  selectedELPListeningAccommodationsNonEmbededIds: any[];
  selectedELPSpeakingUniversalToolsNonEmbededIds: any[];
  selectedELPSpeakingDesignatedSupportsNonEmbededIds: any[];
  selectedELPSpeakingAccommodationsNonEmbededIds: any[];
  selectedELPReadingUniversalToolsNonEmbededIds: any[];
  selectedELPReadingDesignatedSupportsNonEmbededIds: any[];
  selectedELPReadingAccommodationsNonEmbededIds: any[];
  selectedELPWritingUniversalToolsNonEmbededIds: any[];
  selectedELPWritingDesignatedSupportsNonEmbededIds: any[];
  selectedELPWritingAccommodationsNonEmbededIds: any[];

  buttonOptions: any;

  constructor
    (
      private globals: Globals,
      iepService: IepService,
      @Inject('BASE_URL') baseUrl: string,
      public router: Router,
      lookupService: LookupService,
      reportService: ReportService,
      private _formCaliforniaAssessmentTestService: FormCaliforniaAssessmentTestService) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormCaliforniaAssessmentTestDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.scrollToTop();
    this.successMessages = [];
    this.errorMessages = [];

    this.buttonOptions = [{
      label: 'PDF', icon: 'pi pi-file', command: () => {
        this.printEnglish();
      }
    },
    {
      label: 'Excel', icon: 'pi pi-file-excel', command: () => {
        this.printEnglishExcel();
      }
    }
    ];
  }

  LoadFormCaliforniaAssessmentTestDetails(): void {

    this._formCaliforniaAssessmentTestService.getFormCaliforniaAssessmentTest(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormCaliforniaAssessmentTest) => {
        this.formCaliforniaAssessmentTestDB = res,
          this.setSelectedListboxValues();
        this.LoadLookupValues()
      },
        err => console.error(err)
      );
  }

  setSelectedListboxValues() {
    if (this.formCaliforniaAssessmentTestDB.lookupELATestId != null) {
      this.formCaliforniaAssessmentTestDB.lookupELATestId = this.formCaliforniaAssessmentTestDB.lookupELATestId.toString()
      this.selectedElaUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.elaUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elaUniversalToolsEmbededIds.map(String);
      this.selectedElaDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.elaDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elaDesignatedSupportsEmbededIds.map(String);
      this.selectedElaAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.elaAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elaAccommodationsEmbededIds.map(String);
      this.selectedElaUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elaUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elaUniversalToolsNonEmbededIds.map(String);
      this.selectedElaDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elaDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elaDesignatedSupportsNonEmbededIds.map(String);
      this.selectedElaAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elaAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elaAccommodationsNonEmbededIds.map(String);
    }
    if (this.formCaliforniaAssessmentTestDB.lookupMathematicsTestId != null) {
      this.formCaliforniaAssessmentTestDB.lookupMathematicsTestId = this.formCaliforniaAssessmentTestDB.lookupMathematicsTestId.toString()
      this.selectedMathematicsUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.mathematicsUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.mathematicsUniversalToolsEmbededIds.map(String);
      this.selectedMathematicsDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.mathematicsDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.mathematicsDesignatedSupportsEmbededIds.map(String);
      this.selectedMathematicsAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.mathematicsAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.mathematicsAccommodationsEmbededIds.map(String);
      this.selectedMathematicsUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.mathematicsUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.mathematicsUniversalToolsNonEmbededIds.map(String);
      this.selectedMathematicsDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.mathematicsDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.mathematicsDesignatedSupportsNonEmbededIds.map(String);
      this.selectedMathematicsAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.mathematicsAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.mathematicsAccommodationsNonEmbededIds.map(String);
    }
    if (this.formCaliforniaAssessmentTestDB.lookupScienceTestId != null) {
      this.formCaliforniaAssessmentTestDB.lookupScienceTestId = this.formCaliforniaAssessmentTestDB.lookupScienceTestId.toString()
      this.selectedScienceUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.scienceUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.scienceUniversalToolsEmbededIds.map(String);
      this.selectedScienceDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.scienceDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.scienceDesignatedSupportsEmbededIds.map(String);
      this.selectedScienceAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.scienceAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.scienceAccommodationsEmbededIds.map(String);
      this.selectedScienceUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.scienceUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.scienceUniversalToolsNonEmbededIds.map(String);
      this.selectedScienceDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.scienceDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.scienceDesignatedSupportsNonEmbededIds.map(String);
      this.selectedScienceAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.scienceAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.scienceAccommodationsNonEmbededIds.map(String);
    }
    if (this.formCaliforniaAssessmentTestDB.lookupELPTestId != null) {
      this.formCaliforniaAssessmentTestDB.lookupELPTestId = this.formCaliforniaAssessmentTestDB.lookupELPTestId.toString()
      //Listening
      this.selectedELPListeningUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpListeningUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpListeningUniversalToolsNonEmbededIds.map(String);
      this.selectedELPListeningDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpListeningDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpListeningDesignatedSupportsNonEmbededIds.map(String);
      this.selectedELPListeningAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpListeningAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpListeningAccommodationsNonEmbededIds.map(String);
      //Speaking
      this.selectedELPSpeakingUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpSpeakingUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpSpeakingUniversalToolsNonEmbededIds.map(String);
      this.selectedELPSpeakingDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpSpeakingDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpSpeakingDesignatedSupportsNonEmbededIds.map(String);
      this.selectedELPSpeakingAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpSpeakingAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpSpeakingAccommodationsNonEmbededIds.map(String);
      //Reading
      this.selectedELPReadingUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpReadingUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpReadingUniversalToolsNonEmbededIds.map(String);
      this.selectedELPReadingDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpReadingDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpReadingDesignatedSupportsNonEmbededIds.map(String);
      this.selectedELPReadingAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpReadingAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpReadingAccommodationsNonEmbededIds.map(String);
      //Writing
      this.selectedELPWritingUniversalToolsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpWritingUniversalToolsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpWritingUniversalToolsNonEmbededIds.map(String);
      this.selectedELPWritingDesignatedSupportsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpWritingDesignatedSupportsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpWritingDesignatedSupportsNonEmbededIds.map(String);
      this.selectedELPWritingAccommodationsNonEmbededIds = this.formCaliforniaAssessmentTestDB.elpWritingAccommodationsNonEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpWritingAccommodationsNonEmbededIds.map(String);

      //Embeded
      //Listening
      this.selectedELPListeningUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.elpListeningUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpListeningUniversalToolsEmbededIds.map(String);
      this.selectedELPListeningDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.elpListeningDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpListeningDesignatedSupportsEmbededIds.map(String);
      this.selectedELPListeningAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.elpListeningAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpListeningAccommodationsEmbededIds.map(String);
      //Speaking
      this.selectedELPSpeakingUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.elpSpeakingUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpSpeakingUniversalToolsEmbededIds.map(String);
      this.selectedELPSpeakingDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.elpSpeakingDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpSpeakingDesignatedSupportsEmbededIds.map(String);
      this.selectedELPSpeakingAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.elpSpeakingAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpSpeakingAccommodationsEmbededIds.map(String);
      //Reading
      this.selectedELPReadingUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.elpReadingUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpReadingUniversalToolsEmbededIds.map(String);
      this.selectedELPReadingDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.elpReadingDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpReadingDesignatedSupportsEmbededIds.map(String);
      this.selectedELPReadingAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.elpReadingAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpReadingAccommodationsEmbededIds.map(String);
      //Writing
      this.selectedELPWritingUniversalToolsEmbededIds = this.formCaliforniaAssessmentTestDB.elpWritingUniversalToolsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpWritingUniversalToolsEmbededIds.map(String);
      this.selectedELPWritingDesignatedSupportsEmbededIds = this.formCaliforniaAssessmentTestDB.elpWritingDesignatedSupportsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpWritingDesignatedSupportsEmbededIds.map(String);
      this.selectedELPWritingAccommodationsEmbededIds = this.formCaliforniaAssessmentTestDB.elpWritingAccommodationsEmbededIds == null ? null : this.formCaliforniaAssessmentTestDB.elpWritingAccommodationsEmbededIds.map(String);
    }
  }

  LoadLookupValues() {
    // ELA
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELATest]).subscribe((res: any[]) => {
      this.listLookupELATestIds = [] as ILookupBase[];
      this.listLookupELATestIds.push({ label: 'Select an ELA Test (Grades 3-8 and 11)', value: null, shortText: 'Select an ELA Test (Grades 3-8 and 11)', updatedOn: null });
      this.listLookupELATestIds.push.apply(this.listLookupELATestIds, res);
      this.LoadLookupELA();
    },
      err => console.error(err)
    );

    //Mathematics
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.MathematicsTest]).subscribe((res: any[]) => {
      this.listLookupMathematicsTestIds = [] as ILookupBase[];
      this.listLookupMathematicsTestIds.push({ label: 'Select a Mathematics Test (Grades 3-8 and 11)', value: null, shortText: 'Select a Mathematics Test (Grades 3-8 and 11)', updatedOn: null });
      this.listLookupMathematicsTestIds.push.apply(this.listLookupMathematicsTestIds, res);
      this.LoadLookupMathematics();
    },
      err => console.error(err)
    );

    //Science
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ScienceTest]).subscribe((res: any[]) => {
      this.listLookupScienceTestIds = [] as ILookupBase[];
      this.listLookupScienceTestIds.push({ label: 'Select a Science Test (Grades 5, 8 and once in High School)', value: null, shortText: 'Select a Science Test (Grades 5, 8 and once in High School)', updatedOn: null });
      this.listLookupScienceTestIds.push.apply(this.listLookupScienceTestIds, res);
      this.LoadLookupScience();
    },
      err => console.error(err)
    );


    //ELP
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ELPTest]).subscribe((res: any[]) => {
      this.listLookupELPTestIds = [] as ILookupBase[];
      this.listLookupELPTestIds.push({ label: 'Select an EL Proficiency Test (EL students)', value: null, shortText: 'Select an EL Proficiency Test (EL students)', updatedOn: null });
      this.listLookupELPTestIds.push.apply(this.listLookupELPTestIds, res);
      this.LoadLookupELP();
    },
      err => console.error(err)
    );

  }

  changeSelectedValuesELA() {
    this.selectedElaUniversalToolsEmbededIds = [];
    this.selectedElaDesignatedSupportsEmbededIds = [];
    this.selectedElaAccommodationsEmbededIds = [];
    this.selectedElaUniversalToolsNonEmbededIds = [];
    this.selectedElaDesignatedSupportsNonEmbededIds = [];
    this.selectedElaAccommodationsNonEmbededIds = [];
    this.LoadLookupELA()
  }

  LoadLookupELA() {
      var californiaLookupParams = {} as ICaliforniaLookupParams;
      californiaLookupParams.testName = 'NONE';
        if (this.formCaliforniaAssessmentTestDB.lookupELATestId == 2) {
            californiaLookupParams.testName = 'CAASPP';
        }
        else if (this.formCaliforniaAssessmentTestDB.lookupELATestId == 3) {
            californiaLookupParams.testName = 'CAA';
        }
        californiaLookupParams.subjectArea = 'ELA';

    californiaLookupParams.category = 'Universal Tools';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_ELA_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Universal Tools';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_ELA_UniversalTools_Embeded = res;
      this.selectedElaUniversalToolsEmbededIds = [];
      for (let item of res) {
        this.selectedElaUniversalToolsEmbededIds.push(item.value);
      }
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_ELA_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_ELA_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Accommodations';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_ELA_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_ELA_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );
  }

  changeSelectedValuesMathematics() {
    this.selectedMathematicsUniversalToolsEmbededIds = [];
    this.selectedMathematicsDesignatedSupportsEmbededIds = [];
    this.selectedMathematicsAccommodationsEmbededIds = [];
    this.selectedMathematicsUniversalToolsNonEmbededIds = [];
    this.selectedMathematicsDesignatedSupportsNonEmbededIds = [];
    this.selectedMathematicsAccommodationsNonEmbededIds = [];
    this.LoadLookupMathematics()
  }

  LoadLookupMathematics() {
    var californiaLookupParams = {} as ICaliforniaLookupParams;
    californiaLookupParams.testName = 'NONE';
    if (this.formCaliforniaAssessmentTestDB.lookupMathematicsTestId == 2) {
      californiaLookupParams.testName = 'CAASPP';
    }
    else if (this.formCaliforniaAssessmentTestDB.lookupMathematicsTestId == 3) {
      californiaLookupParams.testName = 'CAA';
    }
    californiaLookupParams.subjectArea = 'Mathematics';

    californiaLookupParams.category = 'Universal Tools';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Mathematics_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Universal Tools';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Mathematics_UniversalTools_Embeded = res;
      this.selectedMathematicsUniversalToolsEmbededIds = [];
      for (let item of res) {
        this.selectedMathematicsUniversalToolsEmbededIds.push(item.value);
      }
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Designated Supports';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Mathematics_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Designated Supports';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Mathematics_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Accommodations';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Mathematics_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Accommodations';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Mathematics_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );
  }

  changeSelectedValuesScience() {
    this.selectedScienceUniversalToolsEmbededIds = [];
    this.selectedScienceDesignatedSupportsEmbededIds = [];
    this.selectedScienceAccommodationsEmbededIds = [];
    this.selectedScienceUniversalToolsNonEmbededIds = [];
    this.selectedScienceDesignatedSupportsNonEmbededIds = [];
    this.selectedScienceAccommodationsNonEmbededIds = [];
    this.LoadLookupScience()
  }

  LoadLookupScience() {
    var californiaLookupParams = {} as ICaliforniaLookupParams;
    californiaLookupParams.testName = 'NONE';
    if (this.formCaliforniaAssessmentTestDB.lookupScienceTestId == 2) {
      californiaLookupParams.testName = 'CAST';
    }
    else if (this.formCaliforniaAssessmentTestDB.lookupScienceTestId == 3) {
      californiaLookupParams.testName = 'CAST';  // CAA Note: During UAT Liz said to use the same supports for CAA that are used for CAST
    }
    californiaLookupParams.subjectArea = 'Science';


    californiaLookupParams.category = 'Universal Tools';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Science_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Universal Tools';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Science_UniversalTools_Embeded = res;
      if (this._myGlobals.editMode) { //only autopopulate during editing
        this.selectedScienceUniversalToolsEmbededIds = [];
        for (let item of res) {
          this.selectedScienceUniversalToolsEmbededIds.push(item.value);
        }
      }
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Designated Supports';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Science_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Designated Supports';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Science_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Accommodations';
    californiaLookupParams.isEmbeded = '0';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Science_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );


    californiaLookupParams.category = 'Accommodations';
    californiaLookupParams.isEmbeded = '1';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupCAASSP_Science_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );
  }

  changeSelectedValuesELP() {
    this.selectedELPListeningUniversalToolsNonEmbededIds = [];
    this.selectedELPListeningDesignatedSupportsNonEmbededIds = [];
    this.selectedELPListeningAccommodationsNonEmbededIds = [];
    this.selectedELPSpeakingUniversalToolsNonEmbededIds = [];
    this.selectedELPSpeakingDesignatedSupportsNonEmbededIds = [];
    this.selectedELPSpeakingAccommodationsNonEmbededIds = [];
    this.selectedELPReadingUniversalToolsNonEmbededIds = [];
    this.selectedELPReadingDesignatedSupportsNonEmbededIds = [];
    this.selectedELPReadingAccommodationsNonEmbededIds = [];
    this.selectedELPWritingUniversalToolsNonEmbededIds = [];
    this.selectedELPWritingDesignatedSupportsNonEmbededIds = [];
    this.selectedELPWritingAccommodationsNonEmbededIds = [];
    this.LoadLookupELP()
  }

  LoadLookupELP() {
    var californiaLookupParams = {} as ICaliforniaLookupParams;
    californiaLookupParams.testName = 'NONE'; 
    if (this.formCaliforniaAssessmentTestDB.lookupELPTestId == 2) {
      californiaLookupParams.testName = 'ELPAC';
    }
    californiaLookupParams.isEmbeded = '0';

    // Listening
    californiaLookupParams.subjectArea = 'Listening Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Listening_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Listening_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Listening_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );

    // Speaking
    californiaLookupParams.subjectArea = 'Speaking Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Speaking_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Speaking_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Speaking_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );

    // Reading
    californiaLookupParams.subjectArea = 'Reading Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Reading_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Reading_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Reading_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );

    // Writing
    californiaLookupParams.subjectArea = 'Writing Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Writing_UniversalTools_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Writing_DesignatedSupports_NotEmbeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Writing_Accommodations_NotEmbeded = res;
    },
      err => console.error(err)
    );


    // embeded
    californiaLookupParams.isEmbeded = '1';

    // Listening
    californiaLookupParams.subjectArea = 'Listening Domain';
    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Listening_UniversalTools_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Listening_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Listening_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );

    // Speaking
    californiaLookupParams.subjectArea = 'Speaking Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Speaking_UniversalTools_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Speaking_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Speaking_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );

    // Reading
    californiaLookupParams.subjectArea = 'Reading Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Reading_UniversalTools_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Reading_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Reading_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );

    // Writing
    californiaLookupParams.subjectArea = 'Writing Domain';

    californiaLookupParams.category = 'Universal Tools';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Writing_UniversalTools_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Designated Supports';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Writing_DesignatedSupports_Embeded = res;
    },
      err => console.error(err)
    );

    californiaLookupParams.category = 'Accommodations';
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetCaliforniaLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.CaliforniaAssessmentTest] + '&testName=' + californiaLookupParams.testName + '&subjectArea=' + californiaLookupParams.subjectArea + '&category=' + californiaLookupParams.category + '&isEmbeded=' + californiaLookupParams.isEmbeded).subscribe((res: ILookupBase[]) => {
      this._lookupELP_Writing_Accommodations_Embeded = res;
    },
      err => console.error(err)
    );

  }

  limitListSelection(e, listname) {
    //const LIMIT_NUMBER = 6;
    //this.clearMessages();
    //if (e.value.length > LIMIT_NUMBER) {
    //  let errorMessage: Message = { severity: 'warn', summary: 'Selection Failed', detail: listname + ' :Only 6 items can be selected from the list.' };
    //  this.addselectionMsg(errorMessage);
    //}
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  addselectionMsg(msg: Message) {
    if (!this.selectionMsg)
      this.selectionMsg = [];
    this.selectionMsg = [...this.selectionMsg, msg];
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  SaveSelectedListboxValues() {
    this.formCaliforniaAssessmentTestDB.elaUniversalToolsEmbededIds = this.selectedElaUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elaDesignatedSupportsEmbededIds = this.selectedElaDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elaAccommodationsEmbededIds = this.selectedElaAccommodationsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elaUniversalToolsNonEmbededIds = this.selectedElaUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elaDesignatedSupportsNonEmbededIds = this.selectedElaDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elaAccommodationsNonEmbededIds = this.selectedElaAccommodationsNonEmbededIds;

    this.formCaliforniaAssessmentTestDB.mathematicsUniversalToolsEmbededIds = this.selectedMathematicsUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.mathematicsDesignatedSupportsEmbededIds = this.selectedMathematicsDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.mathematicsAccommodationsEmbededIds = this.selectedMathematicsAccommodationsEmbededIds;
    this.formCaliforniaAssessmentTestDB.mathematicsUniversalToolsNonEmbededIds = this.selectedMathematicsUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.mathematicsDesignatedSupportsNonEmbededIds = this.selectedMathematicsDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.mathematicsAccommodationsNonEmbededIds = this.selectedMathematicsAccommodationsNonEmbededIds;

    this.formCaliforniaAssessmentTestDB.scienceUniversalToolsEmbededIds = this.selectedScienceUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.scienceDesignatedSupportsEmbededIds = this.selectedScienceDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.scienceAccommodationsEmbededIds = this.selectedScienceAccommodationsEmbededIds;
    this.formCaliforniaAssessmentTestDB.scienceUniversalToolsNonEmbededIds = this.selectedScienceUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.scienceDesignatedSupportsNonEmbededIds = this.selectedScienceDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.scienceAccommodationsNonEmbededIds = this.selectedScienceAccommodationsNonEmbededIds;

    //Listening
    this.formCaliforniaAssessmentTestDB.elpListeningUniversalToolsNonEmbededIds = this.selectedELPListeningUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpListeningDesignatedSupportsNonEmbededIds = this.selectedELPListeningDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpListeningAccommodationsNonEmbededIds = this.selectedELPListeningAccommodationsNonEmbededIds;

    this.formCaliforniaAssessmentTestDB.elpListeningUniversalToolsEmbededIds = this.selectedELPListeningUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpListeningDesignatedSupportsEmbededIds = this.selectedELPListeningDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpListeningAccommodationsEmbededIds = this.selectedELPListeningAccommodationsEmbededIds;

    //Speaking
    this.formCaliforniaAssessmentTestDB.elpSpeakingUniversalToolsNonEmbededIds = this.selectedELPSpeakingUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpSpeakingDesignatedSupportsNonEmbededIds = this.selectedELPSpeakingDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpSpeakingAccommodationsNonEmbededIds = this.selectedELPSpeakingAccommodationsNonEmbededIds;

    this.formCaliforniaAssessmentTestDB.elpSpeakingUniversalToolsEmbededIds = this.selectedELPSpeakingUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpSpeakingDesignatedSupportsEmbededIds = this.selectedELPSpeakingDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpSpeakingAccommodationsEmbededIds = this.selectedELPSpeakingAccommodationsEmbededIds;

    //Reading
    this.formCaliforniaAssessmentTestDB.elpReadingUniversalToolsNonEmbededIds = this.selectedELPReadingUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpReadingDesignatedSupportsNonEmbededIds = this.selectedELPReadingDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpReadingAccommodationsNonEmbededIds = this.selectedELPReadingAccommodationsNonEmbededIds;

    this.formCaliforniaAssessmentTestDB.elpReadingUniversalToolsEmbededIds = this.selectedELPReadingUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpReadingDesignatedSupportsEmbededIds = this.selectedELPReadingDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpReadingAccommodationsEmbededIds = this.selectedELPReadingAccommodationsEmbededIds;

    //Writing
    this.formCaliforniaAssessmentTestDB.elpWritingUniversalToolsNonEmbededIds = this.selectedELPWritingUniversalToolsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpWritingDesignatedSupportsNonEmbededIds = this.selectedELPWritingDesignatedSupportsNonEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpWritingAccommodationsNonEmbededIds = this.selectedELPWritingAccommodationsNonEmbededIds;

    this.formCaliforniaAssessmentTestDB.elpWritingUniversalToolsEmbededIds = this.selectedELPWritingUniversalToolsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpWritingDesignatedSupportsEmbededIds = this.selectedELPWritingDesignatedSupportsEmbededIds;
    this.formCaliforniaAssessmentTestDB.elpWritingAccommodationsEmbededIds = this.selectedELPWritingAccommodationsEmbededIds;
  }

  //Save the Present Levels
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.SaveSelectedListboxValues()
    this.showSpinner = true;

    //update values
    this.timeStamp = new Date();
    this._formCaliforniaAssessmentTestService.insertUpdateFormCaliforniaAssessmentTest(this.formCaliforniaAssessmentTestDB)
      .subscribe((res: IFormCaliforniaAssessmentTest) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.showSpinner = false;
        this.LoadFormCaliforniaAssessmentTestDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
          this.showSpinner = false;
        }
      )
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormCaliforniaAssessmentTestDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formCaliforniaAssessmentTestDB.formInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.formCaliforniaAssessmentTestDB.iepId.toString() },
      { parameterName: 'ReportPath', parameterValue: this.formCaliforniaAssessmentTestDB.rdlFileNameEnglish },
      { parameterName: 'PageNumber', parameterValue: '1' }
    );
  }

  printEnglishSplit() {

  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formCaliforniaAssessmentTestDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printEnglishExcel() {
    console.log("printing excel goes here");
    
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "CaliforniaTestAccommodations";

    reportRequest.sqlParamArray = [{ parameterName: 'FormInstanceID', value: this.formCaliforniaAssessmentTestDB.formInstanceId }]

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
    
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formCaliforniaAssessmentTestDB.rdlFileNameSpanish, this.reportParamArray);
  }

}

